import React, { Fragment, useState, useEffect } from "react";
import {
  Col,
  Card,
  CardHeader,
  CardBody,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  FormGroup,
  Form,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
// import { OrderHistoryColumns } from '../../../Data/MockTable/TableHeaderList';
import SweetAlert from "sweetalert2";
import DataTable from "react-data-table-component";
import { H3, Btn, Breadcrumbs, H4 } from "../../AbstractElements";
import { Link, useNavigate } from "react-router-dom";
import { deleteAccount, getAccount } from "../../CommonURL";
import { postDataWithToken } from "../../Utils/restUtils";
import { Add } from "../../Constant";
import SearchList from "../../CommonElements/Search";
// import Transparentspinner from '../../Common/loader/Transparentspinner';

const PendingPaymentReport = () => {
  const style2 = { width: 60, fontSize: 13, padding: 3, marginRight: "10px" };
  const toggleStyle = {
    padding: "10px 20px",
    opacity: "0.8",
    fontSize: "14px",
  };

  // const [accountList, setAccountList] = useState([])
  // const [accountData, setAccountData] = useState([]);
  // const [searchKeyword, setSearchKeyword] = useState('');
  // const [tempSearch, setTempSearch] = useState('');
  // const [loading, setLoading] = useState(false)
  // const navigate = useNavigate();
  // const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const PendingPaymentReportColumns = [
    {
      name: <H4>Sl No</H4>,
      selector: (row) => row.Si,
      sortable: true,
      width: "80px",
    },
   
    {
      name: <H4>User Name</H4>,
      selector: (row) => row.TransactionId,
      sortable: true,
    },
    {
      name: <H4>Transaction/Invoice ID</H4>,
      selector: (row) => row.Industry,
      sortable: true,
    },
     {
      name: <H4>Industry</H4>,
      selector: (row) => row.Company,
      sortable: true,
    },
    {
      name: <H4>Company</H4>,
      selector: (row) => row.Company,
      sortable: true,
    },
     {
      name: <H4>Payment Status</H4>,
      selector: (row) => row.PaymentStatus,
      sortable: true,
    },
    {
      name: <H4>Reason For Failure</H4>,
      selector: (row) => row.NottificationType,
      sortable: true,
    },
     {
      name: <H4>Date</H4>,
      selector: (row) => row.CreaditPurchased,
      sortable: true,
    },
    
  ];

  // useEffect(() => {
  //     industryData(); // do not put await here
  // }, [searchKeyword]);

  // const filteredItems = accountData.filter(
  //     (item) => item.name && item.name.toLowerCase().includes(searchKeyword.toLowerCase()) ||
  //         item.bank_phone && item.bank_phone.toLowerCase().includes(searchKeyword.toLowerCase()) ||
  //         item.account_number && item.account_number.toLowerCase().includes(searchKeyword.toLowerCase()) ||
  //         item.bank_name && item.bank_name.toLowerCase().includes(searchKeyword.toLowerCase())
  // );

  // const updateSearchKeyword = (keyword) => {
  //     setTempSearch(keyword);
  // };

  // const redirectToEditForm = (data) => {
  //     const editFormURL = `${process.env.PUBLIC_URL}/configuration/account-edit?id=${data.id}`;
  //     navigate(editFormURL);
  // };

  // const deleteAccountList = (id) => {
  //     SweetAlert.fire({
  //         title: 'Are you sure?',
  //         text: 'Once deleted, you will not be able to recover this file!',
  //         icon: 'warning',
  //         showCancelButton: true,
  //         confirmButtonText: 'Ok',
  //         cancelButtonText: 'cancel',
  //         reverseButtons: true
  //     }).then(async (result) => {
  //         setLoading(true)
  //             if (result.value) {
  //             const deleteRes = { account_id: id }
  //             const industryDelete = await postDataWithToken(deleteAccount, deleteRes);
  //             if (industryDelete.data.message === 'success') {
  //                 SweetAlert.fire(
  //                     'Deleted!',
  //                     'Your file has been deleted.',
  //                     'success'
  //                 );
  //                 industryData();
  //             } else {
  //                 setLoading(false)
  //                 navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
  //             }
  //         }
  //         //  else {

  //         // }
  //         setLoading(false)
  //     });
  // };

  // const ActionCell = ({ row }) => {
  //     const [dropdownOpen, setDropdownOpen] = React.useState(false);
  //     const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  //     return (
  //         <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
  //             <DropdownToggle color="#00000" style={{ fontSize: '14px', zIndex: 1000 }}>
  //                 <i className="fa fa-ellipsis-v"></i>
  //             </DropdownToggle>
  //             <DropdownMenu container="body">
  //                 <DropdownItem style={toggleStyle} onClick={() => redirectToEditForm(row)}>Edit</DropdownItem>
  //                 <DropdownItem style={{padding: '10px 20px', color: 'red', opacity: '0.8', fontSize: '14px', margin: '0'}} onClick={() => deleteAccountList(row.id)}>Delete</DropdownItem>
  //             </DropdownMenu>
  //         </Dropdown>
  //     );
  // };

  // const industryData = async () => {
  //     setLoading(true)
  //     const data = await postDataWithToken(getAccount);
  //     setResetPaginationToggle(!resetPaginationToggle);
  //     setAccountData(data.data.data)
  //     if (searchKeyword === '') {
  //         setAccountList(data.data.data.map((e, index) => {
  //             return {
  //                 Si: index + 1,
  //                 id:e.id,
  //                 AccountName: e.name,
  //                 OpeningBalance: e.opening_balance,
  //                 BankName: e.bank_name,
  //                 Bankno: e.bank_phone,
  //                 BankAddress: e.bank_address,
  //                 Accountno: e.account_number,
  //                 CreatedBy: e.created_user,
  //                 // action:
  //                 //     <div>
  //                 //         <span>
  //                 //             <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToEditForm(e) }}>Edit </Btn>
  //                 //         </span>
  //                 //         <span>
  //                 //             <Btn attrBtn={{ style: style2, className: 'me-2', color: 'danger btn-xs', type: 'button', onClick: () => { deleteAccountList(e.id) } }}>Delete</Btn>
  //                 //         </span>
  //                 //     </div >
  //             }
  //         }))
  //     } else {
  //         setAccountList(filteredItems.map((e, index) => {
  //             return {
  //                 Si: index + 1,
  //                 id:e.id,
  //                 AccountName: e.name,
  //                 OpeningBalance: e.opening_balance,
  //                 BankName: e.bank_name,
  //                 Bankno: e.bank_phone,
  //                 BankAddress: e.bank_address,
  //                 Accountno: e.account_number,
  //                 CreatedBy: e.created_user,
  //                 // action:
  //                 //     <div>
  //                 //         <span>
  //                 //             <Btn attrBtn={{ style: style2, color: 'primary btn-xs', type: 'button', onClick: () => redirectToEditForm(e) }}>Edit </Btn>
  //                 //         </span>
  //                 //         <span>
  //                 //             <Btn attrBtn={{ style: style2, className: 'me-2', color: 'danger btn-xs', type: 'button', onClick: () => { deleteAccountList(e.id) } }}>Delete</Btn>
  //                 //         </span>
  //                 //     </div >
  //             }
  //         }))
  //     }
  //     setLoading(false)
  // };
  return (
    <Fragment>
      {/* {loading && <Transparentspinner />} */}
      <Breadcrumbs
        mainTitle="Pending Payment"
        parent="Report"
        title="Pending Payment"
      />
      <Card>
        <CardHeader>
          <H3>Pending Payment Report </H3>
        </CardHeader>
        <div
          style={{
            paddingLeft: "22px",
            marginRight: "22px",
            marginBottom: "-20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", float: "left" }}>
            <SearchList />
            <button className="btn btn-primary  mb-2 ms-2  ">Filter</button>
          </div>
          {/* <div style={{ float: "right" }}>
            <Link
              to={`${process.env.PUBLIC_URL}/configuration/account-add`}
              className="btn btn-primary"
            >
              {Add}
            </Link>
          </div> */}
          <div style={{ clear: "both" }}></div>
        </div>
        <CardBody>
          <div className="order-history table-responsive">
            <DataTable
              columns={PendingPaymentReportColumns}
              data={[{}]}
              pagination
              customStyles={{
                rows: {
                  style: {
                    display: "none",
                  },
                },
              }}
            />
          </div>
        </CardBody>
      </Card>
    </Fragment>
  );
};



export default PendingPaymentReport;